/**
 * Project : workspace
 * File    : MobileNumberRow.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.profile

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowCircleRight
import androidx.compose.material.icons.filled.Phone
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import theme.ThemeColor

@Composable
/**
 * Executes the mobile number row operation.
 *
 * @receiver TODO
 * @param viewModel The view model.
 * @return Unit – no return value.
 */
fun MobileNumberRow(viewModel: AuthViewModel) {
    val user = viewModel.authUser.collectAsState()
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(60.dp)
            .padding(start = 8.dp, end = 8.dp)
            .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
            .clip(RoundedCornerShape(10.dp))
            .clickable {

            }
            .padding(5.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            Icons.Default.Phone,
            contentDescription = "Home",
            modifier = Modifier.weight(0.05f), tint = ThemeColor.shared().iconTint
        )
        user.value.MobileNumber.let { Text(it, modifier = Modifier.weight(0.2f)) }
        Icon(
            Icons.Filled.ArrowCircleRight, "Language", modifier = Modifier.weight(0.03f),
            tint = ThemeColor.shared().iconTint
        )
    }
}